import { IdName } from '../../../shared/models';

export class RefundPair {
    refundId: number;
    timestamp: string;
}

export class InvoicePair {
    invoiceId: number;
    timestmap: string;
}

export class AccountingRefund {
    order?: number;
    refund: RefundPair;
    invoice: InvoicePair;
    location: IdName;
    employee: IdName;
    total: number;

    constructor(model: any) {
        Object.assign(this, model);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/shared/models/accounting-refund.ts